import { getIntl, useIntl } from '@umijs/max';

/**
 * 后台双语化 —— 极简翻译助手
 *
 * 约定：i18n 的 **key 就是中文原文**，value 是对应语种。
 *    fm('确定')  →  中文环境「确定」/ 英文环境「OK」
 *
 * 这么设计而不是 'btn.ok' 这类语义 key，是因为：
 *   ① 页面里写 fm('确定') 一眼就知道原文是什么，不用查表
 *   ② 漏翻的条目 defaultMessage 兜底为中文 —— 不会出现空白或把 key 名打到界面上
 *   ③ 中英两个词典可以逐条对账，差集为零才算翻完（见 _scan_admin.py）
 *
 * ⛔ 为什么不用 hook：umi 的 locale 切换会重建全局 intl 并触发整个 app 重渲染，
 *    所以组件渲染时 getIntl() 拿到的就是当前语种。用 hook 反而要求每个组件
 *    都插一行 const fm = useFm()，批量改造时极易漏插或插错位置。
 *    getIntl() 拿不到时（SSR / 初始化早期）返回原文，不会崩。
 */
export function fm(s: string, vars?: Record<string, any>): string {
  try {
    const intl: any = getIntl();
    if (intl && typeof intl.formatMessage === 'function') {
      return intl.formatMessage({ id: s, defaultMessage: s }, vars);
    }
  } catch (e) {
    /* 初始化早期拿不到 intl，返回原文 */
  }
  return s;
}

/**
 * hook 版本（备用）。需要确保跟随语言切换**立即**重渲染的场景可以用它，
 * 但它必须在组件体内调用，批量改造不如 fm() 稳。
 */
export function useFm() {
  const intl = useIntl();
  return (s: string, vars?: Record<string, any>) =>
    intl.formatMessage({ id: s, defaultMessage: s }, vars);
}
